import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import QuestionAnswerFixed from './components/QuestionAnswerFixed';

function TestApp() {
  console.log('🧪 TestApp component is rendering');
  
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" sx={{ mb: 4, textAlign: 'center', color: 'green' }}>
        ✅ React App is Working!
      </Typography>
      
      <Box sx={{ mb: 3 }}>
        <Typography variant="body1" sx={{ mb: 1 }}>
          現在時刻: {new Date().toLocaleString()}
        </Typography>
        <Typography variant="body2" sx={{ mb: 2, fontSize: '0.8rem', color: 'gray' }}>
          ユーザーエージェント: {navigator.userAgent}
        </Typography>
        <button onClick={() => console.log('Button clicked!')} style={{ padding: '8px 16px', marginBottom: '20px' }}>
          Console Logテスト
        </button>
      </Box>

      {/* styled-componentsを使わないQuestionAnswerコンポーネントのテスト */}
      <Typography variant="h5" sx={{ mb: 2 }}>🧪 QuestionAnswer テスト (styled-components無効)</Typography>
      <QuestionAnswerFixed 
        question="あなたの好きな色は何ですか？"
        options={["赤", "青", "緑", "黄色"]}
        mode="edit"
        deadlineDatetime="2025-06-20 12:00:00"
      />
    </Container>
  );
}

export default TestApp;
